﻿export class SelectAllPreference {
    static prompt = 'prompt';
    static allCurrentPage = 'allCurrentPage';
    static all = 'all';
}